import { Badge } from "components/Badge/Badge";
import { IconCoins } from "components/Icons/IconCoins";
import styles from "./CreditsExplained.module.css";
import { Origin } from "./PricingCards";
import cn from "classnames";
import { Tooltip } from "components/Tooltip/Tooltip";

interface Props {
  origin: Origin;
}
export function CreditsExplained(props: Props) {
  const { origin } = props;
  return (
    <div className={cn(styles.box, styles[`origin-${origin}`])}>
      <div className={styles.content}>
        <h1>Credits is how we denominate paid usage on Dune.</h1>
        <div className={styles.description}>
          Credits allow you to flexibly decide how to use Dune's most key
          functionality, so you can freely choose how to trade off query
          executions with execution performance and API data export volumes.
        </div>

        <div className={cn(styles.options, styles[`origin-${origin}`])}>
          <div>
            <h2>Query engine size</h2>
            <ul>
              <li>
                <Tooltip
                  label="Run fast queries more reliably, manually or programmatically"
                  position="above-center"
                >
                  <div>
                    <Badge size="M" color="brand-blue" variant="filled">
                      <IconCoins /> 10 credits
                    </Badge>
                    Medium
                  </div>
                </Tooltip>
              </li>

              <li>
                <Tooltip
                  label="Speed up your more complex workloads."
                  position="above-center"
                >
                  <div>
                    <Badge size="M" color="brand-blue" variant="filled">
                      <IconCoins /> 20 credits
                    </Badge>
                    Large
                  </div>
                </Tooltip>
              </li>
            </ul>
          </div>
          <div>
            <h2>Credit rate API</h2>
            <ul>
              <li>
                <Tooltip
                  label={
                    <>
                      In most cases, datapoints are calculated <br /> by number
                      of rows * columns returned.
                    </>
                  }
                  position="above-center"
                >
                  <div>
                    <Badge size="M" color="brand-blue" variant="filled">
                      <IconCoins /> 1 credit
                    </Badge>
                    1,000 datapoints
                  </div>
                </Tooltip>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
